export enum SupportedLanguages {
  "nl" = "nl",
  "en" = "en",
  "fr" = "fr",
}

export interface ILanguage {
  value: SupportedLanguages;
  label: string;
  short: string;
}

export function getPossibleLanguages(): ILanguage[] {
  return [
    { value: SupportedLanguages.fr, label: "Français", short: "fr" },
    { value: SupportedLanguages.nl, label: "Nederlands", short: "nl" },
    { value: SupportedLanguages.en, label: "English", short: "en" },
  ];
}
